import { ProductListSource } from "client/analytics/types";

import { StorefrontCollectionKind } from "./types";

type CollectionPage = {
  /** URL segment the page lives under, on the storefront and on the catalog API. */
  path: string;
  /** Analytics pageName for the route. */
  pageName: string;
  listSource: ProductListSource;
};

export const COLLECTION_PAGE_BY_KIND: Record<StorefrontCollectionKind, CollectionPage> = {
  [StorefrontCollectionKind.Brand]: {
    path: "brands",
    pageName: "brand",
    listSource: ProductListSource.BrandsPage,
  },
  [StorefrontCollectionKind.Rebate]: {
    path: "deals",
    pageName: "deals_collection",
    listSource: ProductListSource.DealsCollectionPage,
  },
};
